import React from 'react';
import { FadeIn, Section } from './Shared';
export const ClosingSection = () => {
  return <Section bg="teal" className="text-center text-white py-14 md:py-16" data-id="element-35">
      <div className="max-w-xl mx-auto space-y-4" data-id="element-36">
        <FadeIn data-id="element-37">
          <p className="text-2xl md:text-3xl font-heading" data-id="element-38">
            Tu cuerpo no está roto.
          </p>
        </FadeIn>
        <FadeIn delay={0.2} data-id="element-39">
          <p className="text-2xl md:text-3xl font-heading" data-id="element-40">
            Solo está saturado.
          </p>
        </FadeIn>
        <FadeIn delay={0.4} data-id="element-41">
          <div className="h-px w-12 bg-brand-yellow mx-auto my-8" data-id="element-42"></div>
        </FadeIn>
        <FadeIn delay={0.6} data-id="element-43">
          <p className="text-2xl md:text-3xl font-heading text-brand-yellow" data-id="element-44">
            Y cuando limpias el filtro…
          </p>
        </FadeIn>
        <FadeIn delay={0.8} data-id="element-45">
          <p className="text-3xl md:text-4xl font-heading font-bold mt-4" data-id="element-46">
            Todo vuelve a fluir.
          </p>
        </FadeIn>
      </div>
    </Section>;
};